<template>
  <div id="ticketing-step-1" v-if="step === 1">
    <div class="ticketing-content">
      <div class="card">
        <div class="table-responsive">
          <table class="table table-nowrap card-table">
            <thead>
            <tr>
              <th>Loại</th>
              <th class="text-right d-none d-sm-block">Giá tiền</th>
              <th class="text-center">Số lượng</th>
            </tr>
            </thead>
            <tbody v-if="products.length > 0">
            <tr v-for="product in products" :key="product.id">
              <td>
                {{ product.name }}
                <span class="d-block text-muted">
                  Ngày hết hạn: {{ useFormatting().formatDate(product.expiredDate) }}
                </span>
                <span class="d-block d-sm-none text-muted">
                  {{ useFormatting().formatCurrency(product.price) }}
                </span>
              </td>
              <td class="text-right d-none d-sm-block">
                {{ useFormatting().formatCurrency(product.price) }}
              </td>
              <td class="text-center">
                <div class="quantity-toggle">
                  <a class="btn btn-sm btn-rounded-circle btn-white" :class="{ 'disabled': product.quantity === 0 }" @click="onProductPick(product, 'remove')">-</a>
                  <input type="text" min="0" max="10" class="form-control form-control-flush text-dark text-center d-inline" :value="product.quantity" style="width: 30px;" readonly>
                  <a class="btn btn-sm btn-rounded-circle btn-white" :class="{ 'disabled': product.quantity === 10 }" @click="onProductPick(product, 'add')">+</a>
                </div>
              </td>
            </tr>
            </tbody>
            <tbody v-else>
            <tr>
              <td colspan="3">
                Không có sản phẩm nào đang khả dụng.
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useFormatting } from '../composables/formatting';

const props = defineProps({
  products: {
    type: Array,
    required: true
  },
  step: {
    type: Number,
    required: true
  }
})

const emit = defineEmits(['product-pick'])

const onProductPick = (product, action) => {
  emit('product-pick', product, action)
}
</script>

